import { wrapTo, updateMap, updateFilterAnimationSpeed, toggleFilterAnimation, addFilter, setFilter, mapConfigChange } from 'kepler.gl/actions';
import { FlyToInterpolator } from 'deck.gl';

export const initialAnimation = async (store) => {
    // store.dispatch(wrapTo('evidence', addFilter("evidence")));
    // store.dispatch(wrapTo('evidence', setFilter(4, "dataId","evidence", undefined)));
    // store.dispatch(wrapTo('evidence', setFilter(4, "name","time", undefined)));
    // store.dispatch(wrapTo('evidence', updateFilterAnimationSpeed(4, 4)));
    // store.dispatch(wrapTo('evidence', toggleFilterAnimation(4)));
    // await sleep(900);

    store.dispatch(wrapTo('evidence', updateMap({latitude: 22.848943612891574, longitude: 77.82119800542861, zoom: 4.2})));
    await sleep(2000);
    store.dispatch(wrapTo('evidence', updateMap({latitude: 22.848943612891574, longitude: 77.82119800542861, zoom: 4.0, transitionDuration: 2000})));
    await sleep(1000);
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.967583900717138, longitude: 77.58795287278528, altitude : 1.5, zoom: 10.5, transitionDuration: 2500, transitionInterpolator: new FlyToInterpolator()})));
    await sleep(2600);
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.967583900717138, longitude: 77.58795287278528, altitude : 1.5, zoom: 10, transitionDuration: 1000, transitionInterpolator: new FlyToInterpolator()})));
    await sleep(1000)
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.967583900717138, longitude: 77.58795287278528, altitude : 1.5, zoom: 14.45, transitionDuration: 2000, transitionInterpolator: new FlyToInterpolator()})));
    // Enable 3d buildings
    store.dispatch(wrapTo('evidence', mapConfigChange({
        "visibleLayerGroups" : {
            "3d building" : false,
            "border" : false,
            "building" : true,
            "label" : true,
            "land" : true,
            "road" : true,
            "water" : true
        }
    })));

    await sleep(2000);
    store.dispatch(wrapTo('evidence', updateMap({pitch: 60, zoom: 14.45, transitionDuration: 1500, altitude : 1.5, transitionInterpolator: new FlyToInterpolator()})));
    await sleep(1600);
    store.dispatch(wrapTo('evidence', updateMap({pitch: 60, latitude: 12.973161663688202, longitude: 77.58763384825575, zoom: 14.45, altitude : 1.5, transitionDuration: 1000})));
    await sleep(1000);
    store.dispatch(wrapTo('evidence', updateMap({pitch: 60, latitude: 12.9787394267, longitude: 77.5873148237, zoom: 14.45, altitude : 1.5, transitionDuration: 1000})));
    await sleep(1000);

    store.dispatch({ type: 'SHOW_WELCOME_MODAL', payload: true });

    // Bring back the pitch to 0
    // await sleep(1000);
    // store.dispatch(wrapTo('evidence', updateMap({latitude: 12.9787394267, longitude: 77.5873148237, zoom: 15, pitch: 0, altitude : 1.5, transitionDuration: 1000})));
}

export const routeCoverageAnimation = async (store) => {
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.973161663688202, longitude: 77.58763384825575, zoom: 11, altitude : 1.5, transitionDuration: 3000, transitionInterpolator: new FlyToInterpolator()})));
    await sleep(3500);
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.973161663688202, longitude: 77.58763384825575, zoom: 14.45, altitude : 1.5, transitionDuration: 3000, transitionInterpolator: new FlyToInterpolator()})));
    await sleep(3000);
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.9787394267, longitude: 77.5873148237, zoom: 14.45, altitude : 1.5, transitionDuration: 2000})));
    await sleep(2000);
}

export const segmentScoreAnimation = async (store) => {
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.913066, longitude: 77.590932, zoom: 11, altitude : 1.5, transitionDuration: 1000, transitionInterpolator: new FlyToInterpolator()})));
    await sleep(1500);
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.913066, longitude: 77.590932, zoom: 14.85, altitude : 1.5, transitionDuration: 1000, transitionInterpolator: new FlyToInterpolator()})));
    await sleep(500);
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.913066, longitude: 77.590932, zoom: 14.85, altitude : 1.5, transitionDuration: 700})));
    await sleep(900);
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.919257, longitude: 77.589816, zoom: 14.85, altitude : 1.5, transitionDuration: 700})));
    await sleep(900);
}

export const segmentHeatmapScoreAnimation = async (store) => {
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.913066, longitude: 77.590932, zoom: 11, altitude : 1.5, transitionDuration: 1000, transitionInterpolator: new FlyToInterpolator()})));
    await sleep(1500);
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.913066, longitude: 77.590932, zoom: 14.85, altitude : 1.5, transitionDuration: 1000, transitionInterpolator: new FlyToInterpolator()})));
    await sleep(500);
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.913066, longitude: 77.590932, zoom: 14.85, altitude : 1.5, transitionDuration: 700})));
    await sleep(900);
    store.dispatch(wrapTo('evidence', updateMap({latitude: 12.919257, longitude: 77.589816, zoom: 14.85, altitude : 1.5, transitionDuration: 700})));
    await sleep(900);
}

export const selectFilterLatLongAnimation = async (store, latitude, longitude, zoom = 14.45) => {
    store.dispatch(wrapTo('evidence', updateMap({latitude: latitude, longitude: longitude, zoom: zoom, transitionDuration: 2000, transitionInterpolator: new FlyToInterpolator()})));
    await sleep(2000);
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}